import discountsDTO from '@/common/integrations/menhir/employee/discounts/discounts.dto';
import {
  IAmountDiscount,
  IPercentageDiscount,
} from '@/common/integrations/menhir/employee/discounts/discounts.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import {
  IMenhirDiscountPromoCode,
  IMenhirDiscountsList,
} from '@/common/types/menhir/discounts';

const PREFIX = '/employee/discounts';
export const API_ROUTES = {
  DISCOUNTS: `${PREFIX}`,
  PROMO_CODE: `${PREFIX}/promo-code`,
};

const getDiscounts = (): Promise<(IAmountDiscount | IPercentageDiscount)[]> =>
  menhirClient
    .get<null, IMenhirDiscountsList>(API_ROUTES.DISCOUNTS, {
      params: {
        pagination: 'no',
      },
    })
    .then((envelope) =>
      envelope.discounts.list.map(discountsDTO.transformDiscount)
    );

export interface IPostPromoCodeUploadData {
  discount_id: string;
}
const postPromoCode = (discount_id: string) =>
  menhirClient
    .post<null, IMenhirDiscountPromoCode>(API_ROUTES.PROMO_CODE, {
      discount_id,
    })
    .then((envelope) => discountsDTO.transformPromoCode(envelope));

export default {
  getDiscounts,
  postPromoCode,
};
